import styled from 'styled-components'

export default styled.li`
  flex: 1 1 auto;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  list-style: none;
`;
